import { Box, Image, Text, Tooltip } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import React from "react";
import { Link } from "react-router-dom";
import { HiOutlineCode } from "react-icons/hi";
import { AiOutlineEye } from "react-icons/ai";

const Project = ({ projectDetails }) => {
  const fadeIn = keyframes`0%{opacity:0;}
    100%{opacity:1;}`;
  function getRandomInt() {
    const min = 150;
    const max = 400;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const canCodeAccess = (codelink) => codelink?.length > 0;
  const canPreview = (preview_link) => preview_link?.length > 0;

  return (
    <Box
      animation={`${fadeIn}`}
      transitionDelay="0.15s"
      transition="transform 400ms"
      border="1px solid #ffdb70"
      borderRadius="15px"
      _hover={{
        transform: "translateY(-8px)",
        boxShadow: "-2px 8px 60px -12px rgba(255,219,112,0.24)",
      }}
      w="full"
      overflow="hidden"
    >
      {/* image */}
      <Box h={`${getRandomInt()}px`} w="full" pos="relative">
        <Box
          pos="absolute"
          top="0%"
          left="0%"
          w="full"
          h="full"
          zIndex={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={canCodeAccess(projectDetails.code_link) ? 16 : 0}
          bg="rgba(0,0,0,0.5)"
          borderRadius="15px"
        >
          {/* check wheter preview or not */}
          {canPreview(projectDetails.preview_link) && (
            <Tooltip hasArrow label="Preview" placement="top">
              <Box bg="#383838" padding="0.25rem 0.5rem" borderRadius="12px">
                <Link
                  as="a"
                  target="_blank"
                  to={projectDetails.preview_link}
                  rel="noopener noreferrer"
                >
                  <AiOutlineEye color="#ffdb70" fontSize="2.25rem" />
                </Link>
              </Box>
            </Tooltip>
          )}

          {/* check wheter code is accessible or not */}
          {canCodeAccess(projectDetails.code_link) && (
            <Tooltip hasArrow label="Code" placement="top">
              <Box bg="#383838" padding="0.25rem 0.5rem" borderRadius="12px">
                <Link
                  as="a"
                  target="_blank"
                  to={projectDetails.code_link || "/"}
                  rel="noopener noreferrer"
                >
                  <HiOutlineCode color="#ffdb70" fontSize="2.25rem" />
                </Link>
              </Box>
            </Tooltip>
          )}
        </Box>
        <Image
          src={projectDetails?.img_path}
          alt="img"
          borderRadius="15px 15px 0px 0px"
          w="full"
          h="full"
          objectFit="cover"
          overflow="clip"
        />
      </Box>
      {/* content */}
      <Box p="1.25rem">
        <Text
          as="h5"
          fontSize="1.25rem"
          fontWeight="500"
          lineHeight="1.2"
          mb="0.75rem"
          color="#FAFAFA"
        >
          {projectDetails.title}
        </Text>
        <Text
          fontSize="1.1rem"
          mb="1rem"
          wordBreak="break-word"
          lineHeight="1.5"
          color="#D6D6D6B2"
        >
          {projectDetails.description}
        </Text>
        <Text display="flex" alignItems="center" gap={4} flexWrap="wrap">
          {projectDetails.tags.map((tag) => {
            return (
              <Text
                key={tag}
                as="span"
                borderRadius="10rem"
                padding="0.5rem 1rem"
                textAlign="center"
                whiteSpace="nowrap"
                color="#5EEAD4"
                bg="#2dd4bf1a"
              >
                {tag}
              </Text>
            );
          })}
        </Text>
      </Box>
    </Box>
  );
};

export default Project;
